import React from 'react';
import Icon from 'react-icon-base';

const PalmTree = props => (
  <Icon viewBox="0 0 80 81" {...props}>
    <use
      fill="#ECECEC"
      transform="translate(16.8 5.8)"
      xlinkHref="#palm-tree-a"
    />
    <use
      fill="#ECECEC"
      transform="translate(32 1.8)"
      xlinkHref="#palm-tree-b"
    />
    <use
      fill="#ECECEC"
      transform="translate(29.6 1)"
      xlinkHref="#palm-tree-c"
    />
    <use
      fill="#ECECEC"
      transform="translate(32 14.6)"
      xlinkHref="#palm-tree-d"
    />
    <use
      fill="#ECECEC"
      transform="translate(4 10.6)"
      xlinkHref="#palm-tree-e"
    />
    <use fill="#ECECEC" transform="translate(0 17)" xlinkHref="#palm-tree-f" />
    <use fill="#EEE" transform="translate(0 76.2)" xlinkHref="#palm-tree-g" />
    <use
      fill="#ECECEC"
      transform="translate(39.2 28.2)"
      xlinkHref="#palm-tree-h"
    />
    <use
      fill="#ECECEC"
      transform="translate(36.8 33)"
      xlinkHref="#palm-tree-i"
    />
    <use
      fill="#ECECEC"
      transform="translate(32.8 21)"
      xlinkHref="#palm-tree-j"
    />
    <use
      fill="#ECECEC"
      transform="translate(11.2 61)"
      xlinkHref="#palm-tree-k"
    />
    <defs>
      <path
        id="palm-tree-a"
        fillRule="evenodd"
        d="M15.103 17.6C11.713 10.453 6.844 4.167 0 0c7.73 3.185 13.742 8.947 18.4 15.748a5468.1 5468.1 0 0 1-3.297 1.852z"
      />
      <path
        id="palm-tree-b"
        fillRule="evenodd"
        d="M.084 21.136c-.566-5.989 1.73-12.148 6.737-16.394C11.829.495 18.399-.862 24.397.522c.415.095.544.609.223.881l-6.905 5.854a.533.533 0 0 1-.512.097l-3.332-1.12c-.393-.132-.785.2-.706.599l.671 3.376a.503.503 0 0 1-.17.481l-3.042 2.58a.533.533 0 0 1-.512.097L6.319 12.09c-.393-.132-.786.2-.706.599l.764 3.843a.5.5 0 0 1-.17.482l-5.26 4.46c-.321.272-.824.075-.863-.339z"
      />
      <path
        id="palm-tree-c"
        fillRule="evenodd"
        d="M3.84 20.705C1.044 17.936-.464 13.87.129 9.612.72 5.356 3.278 1.887 6.718.039c.238-.127.517.075.478.349L6.38 6.256a.337.337 0 0 1-.204.266l-2.06.85a.355.355 0 0 0-.083.6l1.745 1.412c.092.075.139.194.123.314l-.36 2.585a.338.338 0 0 1-.204.267l-2.345.967a.355.355 0 0 0-.084.6l1.987 1.607c.092.075.139.195.122.314l-.622 4.47a.327.327 0 0 1-.554.197z"
      />
      <path
        id="palm-tree-d"
        fillRule="evenodd"
        d="M34.32 10.36C30.886 4.6 24.896.572 17.848.056 10.8-.46 4.316 2.654.124 7.855c-.278.345-.061.87.374.902l5.564.407a.53.53 0 0 0 .481-.24l1.715-2.61a.599.599 0 0 1 1.048.078l1.339 2.833a.534.534 0 0 0 .443.308l1.8.132a.53.53 0 0 0 .48-.24l1.267-1.928a.794.794 0 0 1 1.39.102l.99 2.092a.535.535 0 0 0 .442.309l6.794.497a.529.529 0 0 0 .48-.24l1.388-2.113a.931.931 0 0 1 1.631.12l1.083 2.293a.536.536 0 0 0 .443.309l4.55.332c.435.033.722-.456.494-.838z"
      />
      <path
        id="palm-tree-e"
        fillRule="evenodd"
        d="M.178 2.015C4.733-.397 10.926-.751 16.983 1.538 23.04 3.828 27.57 8.232 29.57 13.121c.133.325-.201.58-.575.44l-4.783-1.808a.54.54 0 0 1-.333-.333L23.2 9.112c-.104-.353-.605-.542-.902-.341l-1.946 1.317a.512.512 0 0 1-.46.033l-1.548-.585a.541.541 0 0 1-.333-.333l-.5-1.704c-.138-.468-.802-.72-1.196-.452l-1.437.972a.51.51 0 0 1-.461.033l-5.84-2.207a.54.54 0 0 1-.333-.332l-.548-1.869c-.161-.548-.94-.842-1.402-.53L4.72 4.18a.512.512 0 0 1-.461.033L.349 2.736c-.375-.141-.473-.561-.17-.721z"
      />
      <path
        id="palm-tree-f"
        fillRule="evenodd"
        d="M33.418 5.56C28.583 1.095 21.778-1.018 14.904.475 8.031 1.968 2.668 6.725.048 12.81c-.181.42.182.873.622.777l9.477-2.059a.555.555 0 0 0 .41-.377l1.151-3.613a.568.568 0 0 1 .97-.21l2.5 2.82a.547.547 0 0 0 .527.172l4.175-.906a.556.556 0 0 0 .41-.377l1.31-4.113a.568.568 0 0 1 .97-.211l2.847 3.21c.132.15.333.215.526.174l7.219-1.569a.567.567 0 0 0 .256-.968z"
      />
      <path
        id="palm-tree-g"
        d="M70.987 4.018l.131-.483-.13.483zm-9.903 0l-.13-.483.13.483zm-11.567 0l.131-.483-.13.483zm-9.902 0l-.131-.483.13.483zm-11.567 0l-.13.482.13-.482zm-9.901 0l.13.482-.13-.482zm-11.567 0l.131-.483-.13.483zM7.413.783l-.131.483.13-.483zm9.902 0l.13.483-.13-.483zm11.566 0l-.131.482.13-.482zm9.902 0l.13.483-.13-.483zm11.566 0l-.13.483.13-.483zm9.903 0l.13.483-.13-.483zm11.567 0l-.13.483.13-.483zM76.771 4.3c-2.83.004-4.233-.38-5.653-.765l-.261.965c1.42.385 2.953.796 5.914.8v-1zm-5.653-.765c-1.275-.345-2.544-.685-5.082-.69v1c2.406-.004 3.545.31 4.82.655l.262-.965zm-5.082-.69c-2.539.005-3.808.345-5.082.69l.261.965c1.275-.345 2.414-.659 4.82-.654v-1zm-5.083.69c-1.42.385-2.823.77-5.653.765v1c2.962-.004 4.495-.415 5.915-.8l-.262-.965zM55.3 4.3c-2.829.004-4.232-.38-5.652-.765l-.262.965c1.42.385 2.953.796 5.914.8v-1zm-5.652-.765c-1.275-.345-2.544-.685-5.082-.69v1c2.406-.004 3.545.31 4.82.655l.262-.965zm-5.082-.69c-2.538.005-3.807.345-5.082.69l.261.965c1.275-.345 2.415-.659 4.821-.654v-1zm-5.082.69c-1.42.385-2.824.77-5.653.765v1c2.961-.004 4.494-.415 5.914-.8l-.261-.965zM33.83 4.3c-2.828.004-4.232-.38-5.652-.765l-.261.965c1.42.385 2.953.796 5.913.8v-1zm-5.652-.765c-1.274-.346-2.543-.685-5.081-.69v1c2.406-.004 3.545.31 4.82.655l.262-.965zm-5.081-.69c-2.538.005-3.808.344-5.082.69l.262.965c1.274-.346 2.414-.659 4.82-.654v-1zm-5.082.69c-1.42.385-2.823.77-5.652.765v1c2.96-.004 4.494-.415 5.913-.8l-.261-.965zm-5.652.765c-2.83.004-4.233-.38-5.653-.765l-.262.965c1.42.385 2.953.796 5.915.8v-1zM6.71 3.535c-1.275-.345-2.544-.685-5.082-.69v1c2.406-.004 3.546.31 4.82.655l.262-.965zm-5.082-.69C1.018 2.846.5 2.334.5 1.674h-1c0 1.187.941 2.173 2.13 2.173v-1zM.5 1.674C.5 1.013 1.018.5 1.63.5v-1C.44-.5-.5.485-.5 1.673h1zM1.63.5c2.828-.004 4.232.38 5.652.766L7.544.3C6.124-.085 4.59-.496 1.629-.5v1zm5.652.766c1.274.345 2.543.685 5.082.689v-1C9.957.959 8.818.645 7.544.3l-.262.966zm5.082.689c2.538-.004 3.807-.344 5.081-.69L17.184.3c-1.275.346-2.414.66-4.82.655v1zm5.082-.69C18.866.88 20.269.495 23.098.5v-1c-2.96.004-4.494.415-5.914.8l.262.965zM23.098.5c2.829-.004 4.232.38 5.652.765L29.01.3c-1.42-.385-2.952-.796-5.913-.8v1zm5.652.766c1.275.345 2.543.685 5.081.689v-1c-2.406.004-3.545-.31-4.82-.655l-.261.966zm5.081.689c2.539-.004 3.808-.344 5.082-.69L38.652.3c-1.275.346-2.414.66-4.82.655v1zm5.083-.69C40.334.88 41.737.496 44.566.5v-1c-2.961.004-4.494.415-5.914.8l.262.966zM44.566.5c2.83-.004 4.232.38 5.652.766L50.48.3c-1.42-.385-2.953-.796-5.914-.8v1zm5.652.766c1.276.345 2.544.685 5.082.689v-1C52.894.959 51.755.645 50.48.3l-.261.966zm5.082.689c2.539-.004 3.808-.344 5.083-.69L60.12.3c-1.275.346-2.414.66-4.82.655v1zm5.083-.69C61.803.88 63.206.496 66.036.5v-1c-2.961.004-4.495.415-5.915.8l.262.966zM66.036.5c2.829-.004 4.232.38 5.653.766L71.95.3c-1.42-.385-2.953-.796-5.914-.8v1zm5.653.766c1.274.345 2.544.685 5.082.689v-1C74.365.959 73.225.645 71.95.3l-.262.966zm5.082.689c.611 0 1.129.512 1.129 1.173h1c0-1.188-.94-2.173-2.13-2.173v1zM77.9 3.128c0 .66-.518 1.172-1.13 1.172v1c1.19 0 2.13-.985 2.13-2.172h-1z"
      />
      <path
        id="palm-tree-h"
        fillRule="evenodd"
        d="M0 0l.154.226C.104.15.05.076 0 0z"
      />
      <path
        id="palm-tree-i"
        fillRule="evenodd"
        d="M2.826 25.646c.045-.14.088-.281.131-.422 2.123.13 5.425.47 7.867 1.07.35-2.55.458-5.126.314-7.715a16.304 16.304 0 0 0-6.888.117c.014-.149.028-.298.04-.447a16.758 16.758 0 0 1 6.822-.109 39.592 39.592 0 0 0-.613-4.809 44.918 44.918 0 0 0-.41-1.888 14.828 14.828 0 0 0-5.869.698c-.014-.145-.029-.289-.045-.433a15.25 15.25 0 0 1 5.81-.699A46.68 46.68 0 0 0 8.54 6.267a16.85 16.85 0 0 0-5.234.368c-.033-.137-.065-.276-.099-.413a17.26 17.26 0 0 1 5.172-.395A50.794 50.794 0 0 0 5.762 0a10.23 10.23 0 0 0-4.107 1.173v-.002C3.18 5.307 4.151 9.637 4.357 14.057c.301 6.444-1.264 12.5-4.358 18.12L8.33 36a44.825 44.825 0 0 0 2.43-9.284c-2.455-.605-5.853-.944-7.934-1.07z"
      />
      <path
        id="palm-tree-j"
        fillRule="evenodd"
        d="M5.673 12.419A10.283 10.283 0 0 1 9.6 11.256a54.367 54.367 0 0 0-2.827-4.732A9.726 9.726 0 0 0 3.55 7.542c-.061-.125-.124-.249-.187-.372.981-.514 2.05-.863 3.146-1.032-.176-.259-.353-.52-.534-.777A63.22 63.22 0 0 0 3.19 1.713C2.819 1.26 2.34.423 1.836.118c-.302-.182-.19-.161-.548.119-.336.263-.7.51-1.017.796-.35.316-.328.134-.12.577.663 1.418 1.706 2.729 2.456 4.112A52.995 52.995 0 0 1 5.815 12.8c-.046-.127-.094-.254-.142-.381z"
      />
      <path
        id="palm-tree-k"
        fillRule="evenodd"
        d="M6.348 15.36c1.456-.384 2.96-.78 5.923-.78s4.466.396 5.919.778c1.255.33 2.436.642 4.858.642 2.423 0 3.604-.312 4.855-.64 1.457-.384 2.96-.78 5.923-.78 2.964 0 4.467.396 5.92.778 1.255.33 2.436.642 4.858.642 2.423 0 3.605-.312 4.855-.64 1.458-.384 2.96-.78 5.924-.78.214 0 .418.002.617.006C50.012 5.783 39.902 0 28.438 0 16.392 0 5.844 6.388 0 15.953c.443.03.934.047 1.493.047 2.423 0 3.605-.312 4.855-.64z"
      />
    </defs>
  </Icon>
);

export default PalmTree;
